import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class HttpCancelService {
	private _cancelPendingRequestsSubject: Subject<void> = new Subject<void>();

	constructor() {}

	/** Cancels all pending Http requests. */
	cancelPendingRequests(): void {
		this._cancelPendingRequestsSubject.next();
	}

	onCancelPendingRequests(): Observable<void> {
		return this._cancelPendingRequestsSubject.asObservable();
	}
}